module.exports = __webpack_public_path__ + "img/Liefern_buchstaben_2.6d716d8f.png";